const baseURL = 'https://auth.doximity.com'
const clientID = '22dd7b5b68e9ad688404cacbf1d983baf238624dc9f310d9597dfeae21a3c7a1'
const doximityModule = () => {
  const apiRoot = baseURL

  const api = {}
  
  api.initiateOauth = ({ redirectURI, uniqueString }) => {
    const url = `${apiRoot}/oauth/authorize?client_id=${clientID}&response_type=code&redirect_uri=${redirectURI}&scope=basic%20colleagues&type=verify&state=${uniqueString}`
    if (typeof location != 'undefined') {
      location.href = url
    }
  }

  return api
}

const doximity = doximityModule()

export default doximity



// WEBPACK FOOTER //
// ./src/lib/doximitySDK.js